import ACTIVITIES_FORM_KEYS from 'apps/web/constants/forms/activities/formKeys';
import { Portal } from 'apps/web/enums/portal.enum';
import * as yup from 'yup';

import {
  subjectSchema,
  gradeLevelSchema,
  objectiveSchema,
  languageSchema,
  difficultySchema,
  materialsSchema,
  timeSchema,
  curriculumFrameworkSchema,
  specificStandardsSchema,
  strategiesSchema,
} from './fields';

const ActivitiesSchema = (portal: Portal) => {
  const local = {
    [ACTIVITIES_FORM_KEYS.subject]: subjectSchema,
    [ACTIVITIES_FORM_KEYS.gradeLevel]: gradeLevelSchema,
    [ACTIVITIES_FORM_KEYS.objective]: objectiveSchema,
    [ACTIVITIES_FORM_KEYS.language]: languageSchema,
    [ACTIVITIES_FORM_KEYS.difficulty]: difficultySchema,
    [ACTIVITIES_FORM_KEYS.materials]: materialsSchema,
    [ACTIVITIES_FORM_KEYS.time]: timeSchema,
  };

  const american = {
    [ACTIVITIES_FORM_KEYS.curriculumFramework]: curriculumFrameworkSchema,
    [ACTIVITIES_FORM_KEYS.gradeLevel]: gradeLevelSchema,
    [ACTIVITIES_FORM_KEYS.subject]: subjectSchema,
    [ACTIVITIES_FORM_KEYS.specificStandards]: specificStandardsSchema,
    [ACTIVITIES_FORM_KEYS.objective]: objectiveSchema,
    [ACTIVITIES_FORM_KEYS.strategies]: strategiesSchema,
    [ACTIVITIES_FORM_KEYS.difficulty]: difficultySchema,
    [ACTIVITIES_FORM_KEYS.materials]: materialsSchema,
    [ACTIVITIES_FORM_KEYS.time]: timeSchema,
  };

  switch (portal) {
    case Portal.USA:
      return yup.object().shape(american);
    case Portal.PHILIPPINES:
    case Portal.DEFAULT:
      return yup.object().shape(local);
  }
};

export default ActivitiesSchema;
